import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'HEURES'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-74" data-mp="373kpl64kd89i">
      <p className="text-center text-[11px] font-bold uppercase tracking-[0.22em] text-alert" data-id="element-75" data-mp="374vsl3q6qbzk">
        Cette offre expire dans
      </p>
      <div className="mt-3 flex items-stretch justify-center gap-2" role="timer" aria-live="off" data-id="element-76" data-mp="15b6dwosm501j">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-77" data-mp="xzlqdkfr8msu" data-mpi={index}>
            <div className="min-w-[76px] flex-1 max-w-[110px] rounded-xl border border-line bg-ink px-2 py-3 text-center" data-id="element-78" data-mp="t23i7w9kablw">
              <div className="font-display text-3xl font-extrabold tabular-nums text-white sm:text-4xl" data-id="element-79" data-mp="17r9bl3lpx7lv">
                {block.value}
              </div>
              <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500" data-id="element-80" data-mp="12tznpsdz9405">
                {block.label}
              </div>
            </div>
            {index < blocks.length - 1 ? <span className="self-center font-display text-2xl font-bold text-slate-600" data-id="element-81" data-mp="o30mj2fh1hql">:</span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}